'use strict';

/**
 * Add margin bottom to cetexttile if max width of window is 900px
 * @param widthSize
 */
function spaceBottom(widthSize) {
    let textTile = document.querySelectorAll('.ce_text--tile');
    for (let i = 0; textTile.length > i; i++) {
        let textTileItem = textTile[i];
        let textTileContent = textTileItem.querySelector('.ce_text--tile__content');
        let textTileContentHeight = textTileContent.offsetHeight;
        let textTileSpace = textTileContentHeight - '60' + 'px';

        if (widthSize.matches) { // If media query matches
            textTileItem.style.marginBottom = textTileSpace;
        } else {
            textTileItem.style.marginBottom = null;
        }
    }
}

let widthSize = window.matchMedia('(max-width: 900px)');
spaceBottom(widthSize); // Call listener function at run time
widthSize.addListener(spaceBottom); // Attach listener function on state changes
